import { gql } from '@apollo/client'

const youtube = 'iPostId'
const twitter = `
aMedia {
  eMediaType
  sImageURL
  aVariants {
    sURL
    sContentType
  }
  sThumbnail
}
`
const article = `
oArticle {
  sReelContent
  oImg {
    sUrl
    sText
  }
  oSeo {
    sSlug
  }
  sTitle
}
`
export const LIST_REEL_FRONT = gql`
  query listReelFrontV2($input: listReelFrontInput) {
    listReelFrontV2(input: $input) {
      bIsCompleted
      iBundleId
      aData {
        _id
        sHashId
        eStoryType
        nShare
        nLike
        sTitle
        oCustomAuthor {
          oTeam {
            sTitle
            oSeo {
              sSlug
            }
            eTagStatus
            oImg {
              sUrl
            }
          }
          oPlayer {
            sFullName
            eTagStatus
            oSeo {
              sSlug
            }
            oImg {
              sText
              sUrl
            }
            oPrimaryTeam {
              oJersey {
                sUrl
                sText
              }
              oImg {
                sUrl
                sAttribute
              }
              sTitle
            }
          }
          oCategoryFront {
            sName
            oImg {
              sUrl
              sText
            }
            oSeo {
              sSlug
            }
          }
        }
        eCustomAuthorType
        oReelAuthor {
          sAccountName
          sAccountUserName
          sThirdPartyUrl
          oProfileImage {
            sUrl
            sText
          }
        }
        sLink
        sExternalLink
        ${youtube}
        ${twitter}
        ${article}
      }
    }
  }
`
